import {
  defaultAboutPage,
  defaultBasicInfo,
  defaultCapabilityValues,
  defaultCoreFeatures,
  defaultCoreValues,
  defaultMenus,
  defaultPartners,
  defaultProducts
} from "./defaultData";

const STORAGE_KEY = "erp_dual_mock_db";
const STORAGE_SEED_KEY = "erp_dual_mock_db_seed";

function clone(value) {
  return JSON.parse(JSON.stringify(value));
}

function seedData() {
  return {
    menus: clone(defaultMenus),
    basicInfo: clone(defaultBasicInfo),
    partners: clone(defaultPartners),
    products: clone(defaultProducts),
    coreFeatures: clone(defaultCoreFeatures),
    coreValues: clone(defaultCoreValues),
    capabilityValues: clone(defaultCapabilityValues),
    aboutPage: clone(defaultAboutPage)
  };
}

function getSeedSignature() {
  return JSON.stringify(seedData());
}

function resetDb() {
  const initial = seedData();
  localStorage.setItem(STORAGE_KEY, JSON.stringify(initial));
  localStorage.setItem(STORAGE_SEED_KEY, getSeedSignature());
  return initial;
}

export function readDb() {
  const raw = localStorage.getItem(STORAGE_KEY);
  const currentSeedSignature = getSeedSignature();
  const cachedSeedSignature = localStorage.getItem(STORAGE_SEED_KEY);
  if (!raw || cachedSeedSignature !== currentSeedSignature) {
    return resetDb();
  }
  try {
    return JSON.parse(raw);
  } catch (error) {
    return resetDb();
  }
}

export function writeDb(nextDb) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(nextDb));
  localStorage.setItem(STORAGE_SEED_KEY, getSeedSignature());
}

export function getSnapshot() {
  return clone(readDb());
}
